import { SearchQueryParams } from '../types/SearchQuery';

/**
 * Subset of params that are used for search results.
 * @see SearchQueryParams for full set of valid params
 */
export const ALLOWED_PARAMS: (keyof SearchQueryParams)[] = [
  'bareboat',
  'capacity',
  'captained',
  'categories',
  'clat',
  'clon',
  'currency',
  'dates',
  'filters',
  'max_price',
  'min_price',
  'nelat',
  'nelon',
  'page',
  'place_id',
  'swlat',
  'swlon',
  'beta',
  'instabooks',
  'superowners',
  'duration',
  'sort',
];

/**
 * Subset of search params that are arrays
 * @see SearchQueryParams for full set of valid params
 */
export const ARRAY_PARAMS: (keyof SearchQueryParams)[] = [
  'categories',
  'dates',
  'filters',
];
